import * as React from 'react';
import {
  ACTION_SEARCH_FILTERS_OPENED,
  CATEGORY_CITYWIDE_SEARCH,
} from 'utils/analytics/eventTypesConstants';

import pluralize from 'pluralize';

interface SearchFiltersDialogTriggerProps {
  onOpen(): void;
  triggerComponent: React.ReactElement;
  appliedFiltersCount: number;
}

const SearchFiltersDialogTrigger: React.FunctionComponent<SearchFiltersDialogTriggerProps> = ({
  onOpen,
  triggerComponent,
  appliedFiltersCount,
}) => {
  const ariaLabel =
    appliedFiltersCount > 0
      ? `Open additional search filters - ${appliedFiltersCount} search ${pluralize(
          'filter',
          appliedFiltersCount
        )} applied`
      : 'Open additional search filters';

  const filtersApplied = appliedFiltersCount !== 0;

  return (
    <>
      {React.cloneElement(triggerComponent, {
        'aria-label': ariaLabel,
        onClick: () => {
          onOpen();
          window.analytics.sendEvent(CATEGORY_CITYWIDE_SEARCH, ACTION_SEARCH_FILTERS_OPENED);
        },
        selected: filtersApplied,
      })}
    </>
  );
};

export default SearchFiltersDialogTrigger;
